import ApiClient from '../ApiClient';

class WhatsAppSipApiClient extends ApiClient {
  constructor(resource) {
    super(`whatsapp_sip/${resource}`, { accountScoped: true });
  }
}

export default WhatsAppSipApiClient;
